// extracted by mini-css-extract-plugin
export var card = "_9c-0";
export var expandedCard = "_9c-2";
export var paginated = "_9c-1";